import { render, staticRenderFns } from "./semantics.view.vue?vue&type=template&id=501fcbd5&scoped=true"
import script from "./semantics.view.vue?vue&type=script&lang=ts"
export * from "./semantics.view.vue?vue&type=script&lang=ts"
import style0 from "./semantics.view.vue?vue&type=style&index=0&id=501fcbd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501fcbd5",
  null
  
)

export default component.exports